module.exports = __webpack_public_path__ + "static/media/utilita1.a69322c0.png";